import React from 'react';
import { Card, Typography, Button } from 'antd';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import styled from '@emotion/styled';

const { Title } = Typography;

const StatisticsCard = styled(Card)`
  border-radius: 12px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);

  .ant-card-head {
    border-bottom: none;
    padding: 16px 24px;
  }

  .ant-card-body {
    padding: 0 24px 24px;
  }

  @media (max-width: 768px) {
    .ant-card-head {
      padding: 12px 16px;
    }

    .ant-card-body {
      padding: 0 16px 16px;
    }
  }
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  gap: 12px;
  flex-wrap: wrap;
`;

const NavigationButtons = styled.div`
  display: flex;
  gap: 8px;
`;

const NavButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
`;

const ChartContainer = styled.div`
  height: 200px;
  margin-top: 16px;
  display: flex;
  align-items: flex-end;
  gap: 12px;
  padding-bottom: 24px;
  position: relative;
  overflow-x: auto;
  padding-left: 32px;

  @media (max-width: 576px) {
    padding-left: 24px;
  }
`;

const BarContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  min-width: 40px;
`;

const Bar = styled.div`
  width: 18px;
  height: ${props => `${props.height}px`};
  background-color: ${props => (props.isActive ? '#8B5CF6' : '#DDD6FE')};
  border-radius: 4px;
  transition: all 0.3s ease;

  &:hover {
    background-color: #8B5CF6;
  }
`;

const BarLabel = styled.div`
  font-size: 12px;
  color: #6B7280;
`;

const YAxisLabels = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  pointer-events: none;
`;

const YAxisLabel = styled.div`
  font-size: 12px;
  color: #9CA3AF;
`;

const StatisticsSection = () => {
  const data = [
    { day: 'Sun', value: 4, active: false },
    { day: 'Mon', value: 6, active: false },
    { day: 'Tue', value: 8, active: true },
    { day: 'Wed', value: 6, active: false },
    { day: 'Thu', value: 7, active: false },
    { day: 'Fri', value: 4, active: false },
    { day: 'Sat', value: 5, active: false },
  ];

  const maxValue = Math.max(...data.map(item => item.value));
  const yAxisValues = [0, 2, 4, 6, 8, 10];

  return (
    <StatisticsCard title={<Title level={4} style={{ margin: 0 }}>Statistics</Title>}>
      <HeaderContainer>
        <div>Weekly statistics</div>
        <NavigationButtons>
          <NavButton icon={<ChevronLeftIcon style={{ fontSize: 20 }} />} />
          <NavButton icon={<ChevronRightIcon style={{ fontSize: 20 }} />} />
        </NavigationButtons>
      </HeaderContainer>

      <div style={{ textAlign: 'right', color: '#6B7280', fontSize: '14px' }}>
        24 Jan 2025
      </div>

      <ChartContainer>
        <YAxisLabels>
          {yAxisValues.reverse().map(value => (
            <YAxisLabel key={value}>{value}</YAxisLabel>
          ))}
        </YAxisLabels>

        {data.map((item, index) => (
          <BarContainer key={index}>
            <Bar
              height={Math.max(30, (item.value / maxValue) * 150)}
              isActive={item.active}
            />
            <BarLabel>{item.day}</BarLabel>
          </BarContainer>
        ))}
      </ChartContainer>
    </StatisticsCard>
  );
};

export default StatisticsSection;
